import React, { useState, useEffect } from "react";
import "./Attendance.css";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Box,
} from "@mui/material";

const Attendance = ({ user }) => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);

  const now = new Date();
  const monthName = now.toLocaleString("en-US", { month: "long" });
  const year = now.getFullYear();

  useEffect(() => {
    const fetchAttendance = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `https://hr-backend-72v1.onrender.com/my-attendance?email=${user.email}`
        );
        if (!response.ok) throw new Error("Failed to fetch attendance");
        const data = await response.json();
        setRecords(data);
      } catch (error) {
        console.error("Error fetching attendance:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAttendance();
  }, [user.email]);

  const formatTime = (dateStr) =>
    new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
      timeZone: "UTC",
    }).format(new Date(dateStr));

  const calcHours = (checkIn, checkOut) => {
    if (!checkOut) return null;
    const diff = (new Date(checkOut) - new Date(checkIn)) / (1000 * 60 * 60);
    return diff.toFixed(2);
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="300px">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div className="attendance-container">
      <TableContainer component={Paper} className="attendance-table-container">
        <h4 className="attendance-header">
          MY ATTENDANCE - {monthName.toUpperCase()} {year}
        </h4>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell className="myTableHeadCells">
                <span className="myTableHeadSpan">Date</span>
              </TableCell>
              <TableCell className="myTableHeadCells">
                <span className="myTableHeadSpan">Check In</span>
              </TableCell>
              <TableCell className="myTableHeadCells">
                <span className="myTableHeadSpan">Check Out</span>
              </TableCell>
              <TableCell className="myTableHeadCells" align="right">
                <span className="myTableHeadSpan">Hours Worked</span>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {records.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} align="center" sx={{ fontSize: "large", py: 4 }}>
                  No attendance records for {monthName} {year}.
                </TableCell>
              </TableRow>
            ) : (
              records.map((r, i) => {
                const hours = calcHours(r.checkIn, r.checkOut);
                return (
                  <TableRow key={i}>
                    <TableCell sx={{ fontSize: "large" }}>
                      {new Date(r.checkIn).toISOString().split("T")[0]}
                    </TableCell>
                    <TableCell sx={{ fontSize: "large" }}>
                      {formatTime(r.checkIn)}
                    </TableCell>
                    <TableCell sx={{ fontSize: "large" }}>
                      {r.checkOut ? (
                        formatTime(r.checkOut)
                      ) : Date.now() - new Date(r.checkIn).getTime() < 12 * 60 * 60 * 1000 ? (
                        <span className="still-active-badge">Still Active</span>
                      ) : (
                        <span className="no-checkout-badge">No Checkout</span>
                      )}
                    </TableCell>
                    <TableCell sx={{ fontSize: "large" }} align="right">
                      {hours !== null ? `${hours} hrs` : "-"}
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default Attendance;
